import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { name: { type: String, default: "default" } };

  connect() {
    sessionStorage.removeItem(this.#storageKey);
    this.activate(this.tabTargets[0]?.dataset.tabId);
    document.addEventListener("turbo:morph", this.restore);
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.restore);
  }

  showTab(event) {
    const tabId = event.currentTarget.dataset.tabId;
    sessionStorage.setItem(this.#storageKey, tabId);
    this.activate(tabId);
  }

  restore = () => {
    this.activate(this.#currentTabId());
  };

  activate(tabId) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabId === tabId;
      tab.classList.toggle("active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabId !== tabId;
    });
  }

  get #storageKey() {
    return `inspector-tabs:${this.nameValue}:selected`;
  }

  #currentTabId() {
    const stored = sessionStorage.getItem(this.#storageKey);
    if (this.tabTargets.some((t) => t.dataset.tabId === stored)) {
      return stored;
    }
    return this.tabTargets[0]?.dataset.tabId;
  }
}
